import { useEffect, useMemo, useState } from "react";
import { LeadType } from "../../../../services/LeadService";
import { ItemType } from "../../../../util/hooks/useCatalog";

import { FilterLeadType, LeadTypes, ResponsibleTypes } from "../../../customwidgets/leads-tracking-report/types";
import moment from "moment";


export const FILTER_VALID_DAYS_DOWNLOAD = 30
export const ACTIVITY_START_DATE = new Date(2022, 1, 15);

export const useDefaultFilters = (status: ItemType[]): FilterLeadType => {

    const defaltFilters = useMemo(() => {
        const statusNames = [...status].filter(s => s.metadata.is_search).map(s => s.name) as string[];
        const now = moment().utc().endOf('day').toDate()
        const start = moment().startOf('day').subtract(FILTER_VALID_DAYS_DOWNLOAD, "days").toDate()
        const newFilters = {
            lead_type: ["PM", "PFAE"] as LeadType[],
            lead_status: [...statusNames],
            lead_responsible: ["Cliente", "Operaciones"] as ResponsibleTypes[],
            lead_email: "",
            lead_tax_id: "",
            lead_social_reason: "",
            dates: {
                start: start,
                end: now,
            },

        }
        return newFilters
    }, [status])

    return defaltFilters && defaltFilters.lead_status.length > 0 ? defaltFilters : null
}



export const useFilterLead = (selectedFilters: FilterLeadType, onConfirm: (selectedFilters: FilterLeadType) => void, open: boolean, status: ItemType[], isDownload: boolean) => {

    const [statusSelected, setStatusSelected] = useState<any>({});
    const [leadType, setLeadType] = useState<string>('todos');
    const [leadResponsible, setLeadResponsible] = useState<string>("todos");
    const [fechaInicio, setFechaInicio] = useState<string>();
    const [fechaFin, setFechaFin] = useState<string>();

    const [isValidFilters, setIsValidFilters] = useState<boolean>(true);

    useEffect(() => {
        const dayDiff = Math.floor((Date.parse(fechaFin) - Date.parse(fechaInicio)) / 86400000);
        const isValidDate = Date.parse(fechaFin) >= Date.parse(fechaInicio)

        setIsValidFilters(isDownload ? dayDiff <= FILTER_VALID_DAYS_DOWNLOAD && isValidDate : isValidDate)


    }, [fechaFin, fechaInicio, isDownload])

    useEffect(() => {
        const statusTmp = {}
        selectedFilters?.lead_status?.forEach(s => statusTmp[s] = true)
        setStatusSelected(statusTmp)

        const leadTypeTmp = selectedFilters?.lead_type?.length === 1 ? selectedFilters.lead_type[0] : "todos";
        setLeadType(leadTypeTmp);

        const leadResponsibleTmp = selectedFilters?.lead_responsible?.length === 1 ? selectedFilters.lead_responsible[0] : "todos";
        setLeadResponsible(leadResponsibleTmp)
        if (isDownload) {
            const start = moment().startOf('day').subtract(FILTER_VALID_DAYS_DOWNLOAD, "days").toDate()
            setFechaInicio(start.toISOString().substring(0, 10))
            setFechaFin(moment().startOf('day').toDate().toISOString().substring(0, 10))
        } else {
            setFechaFin(selectedFilters?.dates?.end?.toISOString().substring(0, 10))
            setFechaInicio(selectedFilters?.dates?.start?.toISOString().substring(0, 10))
        }

    }, [selectedFilters, open, isDownload])

    const filter = () => {
        const allStatusSelected = {}
        status?.forEach(s => allStatusSelected[s.name] = true)

        const leadStatus = Object.entries(statusSelected).filter(s => s[1]).length > 0 ?
            Object.entries(statusSelected).filter(s => s[1]).map(s => s[0])
            : Object.entries(allStatusSelected).filter(s => s[1]).map(s => s[0])

        const endDateTime = moment(new Date(fechaFin)).utc().endOf('day').toDate();
          
        const filtros = {
            ...selectedFilters,
            lead_type: [...(leadType === "todos" ? ['PM', 'PFAE'] : [leadType])] as LeadTypes[],
            lead_status: leadStatus,
            lead_responsible: [...(leadResponsible === "todos" ? ['Cliente', 'Operaciones'] : [leadResponsible])] as ResponsibleTypes[],
            lead_social_reason: "",
            lead_email: "",
            lead_tax_id: "",
            dates: {
                start: new Date(fechaInicio),
                end: endDateTime,
            },

        }
        onConfirm(filtros)

    }
    const onSelectStatus = (e) => {
        const obj = { ...statusSelected }
        obj[e.target.value] = e.target.checked
        setStatusSelected(obj)
    }
    const handleBorrarFiltros = () => {
        const statusTmp = {}
        status?.forEach(s => statusTmp[s.name] = false)
        setStatusSelected(statusTmp)

    }

    return { filter, onSelectStatus, statusSelected, handleBorrarFiltros, fechaInicio, setFechaInicio, leadType, setLeadType, leadResponsible, setLeadResponsible, fechaFin, setFechaFin, isValidFilters }
}